import React from "react";
import { PolarAngleAxis, RadialBar, RadialBarChart } from "recharts";

const SemiCircleChart = ({ selectedTab, chartData }) => {
  // Dynamically generate chart data
  const formattedData = [
    { name: selectedTab, value: chartData, fill: "#2E4A8F" }, // Active portion
    { name: "Remaining", value: 100 - chartData, fill: "#E5E5E5" }, // Greyed out part
  ];

  return (
    <div className="flex flex-col items-center">
      <RadialBarChart
        width={300}
        height={180}
        cx="50%"
        cy="100%"
        innerRadius="80%"
        outerRadius="100%"
        data={formattedData}
        startAngle={180}
        endAngle={0}
      >
        <PolarAngleAxis
          type="number"
          domain={[0, 100]}
          angleAxisId={0}
          tick={false}
        />
        <RadialBar background dataKey="value" />
        <text x="50%" y="55%" textAnchor="middle" fontSize={24} fill="#2E4A8F">
          {chartData}
        </text>
      </RadialBarChart>
    </div>
  );
};

export default SemiCircleChart;
